"use strict";

class InformacionPCDController {
  constructor(
    $uibModalInstance,
    data,
    $log,
    DataService,
    Message,
    $state,
    $scope,
    $http,
    apiUrl,
    Loading,
    helpLang,
    Storage
  ) {
    "ngInject";
    this.persona = data;
    this.$uibModalInstance = $uibModalInstance;
    this.$log = $log;
    this.DataService = DataService;
    this.Message = Message;
    this.$state = $state;
    this.$scope = $scope;
    this.apiUrl = apiUrl;
    this.$http = $http;
    this.Loading = Loading;
    this.helpLang = helpLang;
    this.Storage = Storage;
    this.validaciones = [];
    this.validacion = false;
  }

  $onInit() {
    this.obtenerValidacionesRegistro();
  }

  obtenerValidacionesRegistro() {
    this.$log.log("Datos desde tabla", this.persona);
    this.DataService.get(
      `centralizador/soporte-detalle-pcd/${this.persona.nro_documento}?fechaNacimiento=${this.persona.fecha_nacimiento}`
    ).then((respuesta) => {
      this.registro = respuesta.datos;
      this.$log.log("Respuesta de servicio", this.registro);
    });
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
}

export default InformacionPCDController;



// WEBPACK FOOTER //
// ./src/app/components/soporte/casosPCD/casosPCD.informacion.controller.js